<template>
  <div class="player text-white" v-if="code" :key="mode">
    <div class="embed-responsive embed-responsive-16by9" v-if="mode == 'offline'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <h1>Offline</h1>
        <p>Currently not broadcasting</p>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9" v-else-if="mode == 'pre'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <vue-countdown :time="time" v-if="time && time > 0">
          <template slot-scope="props">
            <div class="h4 m-0">
              {{ props.days }} {{ props.days == 1 ? "day" : "days" }},
              {{ props.hours }} {{ props.hours == 1 ? "hour" : "hours" }},
              {{ props.minutes }} {{ props.minutes == 1 ? "minute" : "minutes" }},
              {{ props.seconds }} {{ props.seconds == 1 ? "second" : "seconds" }}
            </div>
          </template>
        </vue-countdown>
      </div>
    </div>
          
    <div class="embed-responsive embed-responsive-16by9" v-else-if="mode == 'live'">
      <div class="embed-responsive-item">
        <jwplayer :file="event.streamUrl"></jwplayer>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9" v-else-if="mode == 'post'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <h1>Thank you</h1>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9" v-else-if="mode == 'ondemand'">
      <iframe :src="event.ondemandUrl" class="embed-responsive-item" allowtransparency="true" frameborder="0" scrolling="no" seamless allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen></iframe>
    </div>

    <!-- Disabled -->
    <div class="embed-responsive embed-responsive-16by9" v-if="false">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <h1>Participation code used</h1>
        <p class="text-center">
          Your participation code has been used on another device.<br>
          A participation code can only be used on one device at a time.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import VueCountdown from "@chenfengyuan/vue-countdown"
  import Jwplayer from "@/components/jwplayer"

  export default {
    name: "player",
    components: { VueCountdown, Jwplayer },
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        settings: null,
        code: null,
        eventTimezone: "Europe/Stockholm",
        time: null,
      }
    },
    computed: {
      codeValid() {
        return this.code && this.code.currentUser == this.$store.state.currentUser.uid
      },
      mode() {
        let testMode = new URLSearchParams(window.location.search).get("wearejaws")
        let eventEnded = false
        let now = this.$DateTime.local().setZone(this.eventTimezone)

        if(this.eventEndObject && now >= this.eventEndObject) {
          eventEnded = true
        }

        if(testMode == "true") { return "live" }
        else if(testMode) { return testMode }
        else if(eventEnded) { return "offline" }
        else if(this.event.mode) { return this.event.mode }
        else { return "offline" }
      },
      eventStartObject() {
        let startDateISO = this.event.eventStart.toDate().toISOString()
        return this.$DateTime.fromISO(startDateISO, { zone: this.eventTimezone })
      },
      eventEndObject() {
        if(this.event.eventEnd) {
          let endDateISO = this.event.eventEnd.toDate().toISOString()
          return this.$DateTime.fromISO(endDateISO, { zone: this.eventTimezone })
        }

        return null
      }
    },
    methods: { },
    async mounted() {
      if(this.event.codesEnabled) {
        let codeObject = this.$store.state.currentCode[this.event.id]

        if(codeObject) {
          let codeRef = await firebase.firestore().collection(`codes`).doc(codeObject.codeString)
          let code = await codeRef.get()
          this.code = await code.data()
        }

        if(this.code == null || this.code.eventId != this.event.id) {
          this.closePlayer()
        }
      } else {
        this.code = true
      }

      let now = this.$DateTime.local().setZone(this.eventTimezone)
      let millis = this.eventStartObject.diff(now).toObject()

      this.time = millis.milliseconds
    }
  }
</script>